import { Fragment } from 'react';
import { Loading } from 'tdesign-react';

import { useTypedSelector } from '@/store';

import { AuthIDEnum } from './authID';
import styles from './index.module.less';

export interface AuthWrapperProps {
  children?: React.ReactNode;
  id?: AuthIDEnum;
  className?: string;
  redirect?: boolean
  authHidden?: boolean
}

const AuthWrapper = (props: AuthWrapperProps) => {
  const { loading } = useTypedSelector(store => store.auth);

  if (loading) {
    return (
      <div className={styles.loading}>
        <Loading
          indicator
          size="small"
          loading={true}
          preventScrollThrough
          showOverlay
        />
      </div>
    );
  }
  return (
    <Fragment>
      {props.children}
    </Fragment>
  );
};

export default AuthWrapper;
